import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./components/Auth/Login";
import Dashboard from "./components/dashboard/Dashboard";
import ExerciseList from "./components/ExerciseList";
import NotFound from "./components/notfound/NotFound";
import Sidebar from "./components/sidebar/Sidebar";
import ProgrammList from "./components/programms/ProgrammList";
import ProgramDetail from "./components/programms/ProgramDetail";
import CreateProgramm from "./components/programms/CreateProgramm";
import CreateWorkout from "./components/workout/CreateWorkout";
import EditProgramm from "./components/programms/EditProgramm";
import ForgotPassword from "./components/Auth/ForgotPassword";
import CreateGroup from "./groups/CreateGroup";
import ChangePassword from "./components/Auth/ChangePassword";
import { useEffect } from "react";
import { CORPORATE_LOGO, CORPORATE_NAME } from "./api/Constants";

const basename = process.env.REACT_APP_BASENAME || "/";

function App() {
  useEffect(() => {
    if (CORPORATE_NAME) document.title = CORPORATE_NAME;
    if (CORPORATE_LOGO) {
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.href = CORPORATE_LOGO;
      }
    }
  }, []);
  return (
    <div className="App" id="app-elements">
      <div className="blur" style={{ top: "-18%", right: "0" }}></div>
      <div className="blur" style={{ top: "36%", left: "-8rem" }}></div>
      <div>
        <Router basename={basename}>
          <Routes>
            {/* <Route exact path='/register'  element={<Register/>}/> */}
            <Route exact path="/trainer/" element={<Login />} />
            <Route exact path="/forgot" element={<ForgotPassword />} />
            <Route exact path="/change" element={<ChangePassword />} />
            <Route exact path="/group" element={<CreateGroup />} />
            <Route exact path="/sidebar" element={<Sidebar />} />
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/trainer/dashboard" element={<Dashboard />} />
            <Route exact path="/programm-list" element={<ProgrammList />} />
            <Route exact path="/create-program" element={<CreateProgramm />} />
            <Route exact path="/exercises" element={<ExerciseList />} />

            <Route exact path="/edit-programm/:id" element={<EditProgramm />} />
            <Route
              exact
              path="/create-workout/:pid/:wid?"
              element={<CreateWorkout />}
            />
            
            <Route
              exact
              path="/programmdetail/:id"
              element={<ProgramDetail />}
            />

            <Route path="*" element={<Login />} />
          </Routes>
        </Router>
      </div>
    </div>
  );
}

export default App;
